import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Handshake } from "lucide-react";

export default function ForVenues({ onPartnerWithUs }) {
  return (
    <section
      id="venues"
      className="py-24 sm:py-32 bg-muted/50"
      data-testid="for-venues-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
          >
            <div className="w-12 h-12 rounded-sm bg-secondary flex items-center justify-center mb-6">
              <Handshake className="w-6 h-6 text-[hsl(var(--accent))]" strokeWidth={1.5} />
            </div>
            <p className="font-mono text-xs tracking-[0.2em] uppercase font-semibold text-[hsl(var(--accent))] mb-4">
              For cafes, bars & brands
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight font-medium mb-6">
              Partner with Cita Rush
            </h2>
            <p className="text-base leading-relaxed text-muted-foreground mb-6 max-w-lg">
              We bring curated, high-quality foot traffic to your venue on select evenings. 
              Professional hosting, brand-safe events, and a community of young professionals 
              who appreciate good spaces. If you run a cafe, restaurant, bar, or event space 
              in Pune, let's create something special together.
            </p>
            <Button
              size="lg"
              onClick={onPartnerWithUs}
              className="rounded-sm px-8 py-6 text-base font-medium tracking-wide transition-all duration-300 hover:-translate-y-0.5"
              data-testid="partner-with-us-btn"
            >
              Partner with us
            </Button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="hidden lg:block"
          >
            <div className="relative rounded-sm overflow-hidden aspect-[4/3]">
              <img
                src="https://images.unsplash.com/photo-1761138785160-b1d4f7b900da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxjb3VwbGUlMjByb21hbnRpYyUyMGRpbm5lciUyMHJlc3RhdXJhbnR8ZW58MHx8fHwxNzc2MzQ4NzUxfDA&ixlib=rb-4.1.0&q=85"
                alt="People dining elegantly at tables in a luxury restaurant"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background/30 to-transparent" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
